module.exports = __webpack_public_path__ + "static/img/t1.60d459e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/safes/t1.png
// module id = clv0
// module chunks = 0